import { useIntl } from "react-intl";

import { useSearchParameters } from "@/components/signup/hooks";
import { CardsGrid } from "@/templates/ondemand/signup/confirmation/confirmation-page/src/views/user-seg-bxp-ui/cards-grid.tsx";

import {
    JiraOnboardingContainer,
    TwcOnboardingContainer
} from "../../components/jira-onboarding-container/jira-onboarding-container";
import { ProductKey } from "../../models";

type MessagesType = {
    readonly teamFocus: string;
    readonly personalizeJira: string;
};

const TeamFocusView = () => {
    const intl = useIntl();
    const searchParameters = useSearchParameters();
    const { products = [] } = searchParameters;

    const isJsm = products.includes(ProductKey.JIRA_SERVICE_MANAGEMENT);
    const isTwc = products.includes(ProductKey.TEAMWORK_COLLECTION);

    if (isTwc) {
        return (
            <TwcOnboardingContainer
                header={intl.formatMessage({
                    id: "UserSeg.teamTypeSelection.twc.header",
                    defaultMessage: "First, let's start with a project in Jira"
                })}
                subheader={intl.formatMessage({
                    id: "UserSeg.teamTypeSelection.twc.subHeader",
                    defaultMessage:
                        "Choose the team that best reflects what you do for work. This helps us personalize how you'll get started."
                })}
            >
                <CardsGrid />
            </TwcOnboardingContainer>
        );
    }

    const messages: MessagesType = isJsm
        ? {
              teamFocus: intl.formatMessage({
                  id: "UserSeg.teamTypeSelection.header",
                  defaultMessage: "What kind of work do you do?"
              }),
              personalizeJira: intl.formatMessage({
                  id: "UserSeg.teamTypeSelection.jsm.subHeader",
                  defaultMessage: "This helps us personalize your experience"
              })
          }
        : {
              teamFocus: intl.formatMessage({
                  id: "UserSeg.teamTypeSelection.header",
                  defaultMessage: "What kind of work do you do?"
              }),
              personalizeJira: intl.formatMessage({
                  id: "UserSeg.teamTypeSelection.transparentTemplateForAll.subHeader",
                  defaultMessage:
                      "This helps us suggest templates that help your team do their best work."
              })
          };

    return (
        <JiraOnboardingContainer
            header={messages.teamFocus}
            subheader={messages.personalizeJira}
        >
            <CardsGrid />
        </JiraOnboardingContainer>
    );
};

export default TeamFocusView;
